<template>
  <div id="login">
    <div id="form">
      <h1>消费券核销系统</h1>
      <el-form ref="form" :model="form" style="width: 90%">
        <el-form-item>
          <el-input v-model="form.account">
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" type="password">
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" round style="width: 100%">登录</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>

</template>

<script>

import {getLoginInfo, login} from "@/api/admin";
import {setToken, setUserInfo} from "@/api/util";

export default {
  name: 'app',
  data() {
    return {
      form: {
        account: '',
        password: '',
      }
    }
  },
  methods: {
    async onSubmit() {
      console.log(this.form)
      const res = await login({title:this.form.account, password: this.form.password});
      if (!res.access_token) {
        this.$message.error('账号或密码错误')
        return;
      }
      await setToken(res.access_token);
      const info = await getLoginInfo({})
      await setUserInfo(JSON.stringify(info.user_info))
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
#login {
  width: 100%;
  height: 100%;
  background-color: #2d3a4b;
  position: absolute;
}

#login h1 {
  color: white;
}
#form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 20%;
}
</style>
